<template>
  <div class="flex-center-col bd-[2px_var(--theme-primary)] rounded-8 w-[342px] p-[24px_16px_16px] text-white">
    <h3 v-if="title" class="text-18 font-[600] leading-22">{{ title }}</h3>
    <slot />
    <div class="flex w-full gap-4 pt-4 text-white" :class="horizental ? 'flex-row-reverse' : 'flex-col'">
      <van-button @click="confirm" class="primaryBtn">{{ confirmText }}</van-button>
      <van-button v-if="cancelBtn" @click="cancel" class="primaryBtn_transparent">{{ cancelText }}</van-button>
    </div>
    <slot name="footer" />
  </div>
</template>

<script setup lang="ts">
  const props = withDefaults(
    defineProps<{
      title?: string
      confirmText?: string
      cancelText?: string
      onConfirm?: () => void
      onCancel?: () => void
      horizental?: boolean
      cancelBtn?: boolean
    }>(),
    {
      title: '',
      confirmText: 'Confirmar',
      cancelText: 'Cancelar',
      cancelBtn: false,
      onConfirm: () => { },
      onCancel: () => { },
      horizental: false,
    },
  )

  const close = inject('close', () => { })

  const confirm = () => {
    props.onConfirm()
    close()
  }

  const cancel = () => {
    props.onCancel()
    close()
  }
</script>
